/**
 * emailRegex: Validates an email with alphanumeric, periods, plus, hyphen, underscores,
 * and a domain with 2+ characters after a dot.
 */
export const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

/**
 * passwordRegex: Validates passwords with at least 8 characters, including an uppercase
 * letter, a digit, and a special character.
 */
export const passwordRegex =
  /^(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/;

/**
 * regex for checking non-numeric characters
 */
export const nonDigitRegex = /\D/g;

//phone regex
export const phoneRegex = /^\d{10}$/;

//name regex
export const nameRegex = /^[A-Za-z]+$/;
